import React, { useState, useEffect, useRef } from "react";
import pClasses from "../ListUsersAndAdmins.module.scss";
import FriendlyInfo from "../../FriendlyInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as a from "../../../constants/api";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import {
  faFileAlt,
  faIdCard,
  faDumbbell,
  faTrophy,
  faUser,
  faCopy,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import * as h from "../../../helpers";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import {
  DataGrid,
  GridColDef,
  GridLocaleText,
  getGridStringOperators,
} from "@mui/x-data-grid";
import {
  createTheme,
  ThemeProvider,
  withStyles,
} from "@mui/material/styles";
import Button from "@mui/material/Button";
import Profile from "../../Profile";
import Tooltip from "@mui/material/Tooltip";
import { copyFunc } from "../../../helpers/utilityHelper";
import { useLocation } from "react-router";
interface Interface {
  users?: any;
  company_uid?: any;
  className?: string;
  companyUid?: string | null;
  showUser?: boolean;
  hideFilter?: boolean;
  showActiveStatus?: boolean;
  showReportUser?: boolean;
  showReportUserSmart?: boolean;
  showBirthdate?: boolean;
  showCompany_uid?: boolean;
  showAccess_code?: boolean;
  showIaStart?: boolean;
  showIaFinish?: boolean;
  showDownloadListButton?: boolean;
  showActionButton?: boolean;
  configFields?: any;
  callback?: any;
  CustomToolbar?: any;
  handleDelete?: any;
  setHasUserChangedGroup: () => boolean | void;
  handleSelectRowsToSetGroup?: (u: any) => boolean | void;
  setHandleGroup?: (u: any) => any | void;
  hasUserChangedGroup?: boolean;
}

export default function ListUsers({
  className = "",
  users = null,
  company_uid = "",
  configFields,
  callback,
  CustomToolbar,
  handleDelete,
  handleSelectRowsToSetGroup,
  setHandleGroup,
  hasUserChangedGroup
}: Interface) {
  const { t } = useTranslation();
  const [usersRows, setusersRows] = useState<any[]>([]);
  const listUsers = [] as Array<any>;
  const [open, setOpen] = React.useState(false);
  const [userProfile, setuserProfile] = useState<any>([]);
  const [dataGrid, setDataGrid] = useState(<></>);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState<any>({
    birthdate: false,
    group_name: false,
    date_IA_start: false,
    access_code: false,
    date_last_play: false,
    professional_email: false,
    url: false,
  });

  const customLocaleText: Partial<GridLocaleText> = {
    toolbarColumns: t("global.toolbarColumns"),
    filterPanelOperator: t("global.filterPanelOperator"),
    filterPanelColumns: t("global.filterPanelColumns"),
    filterPanelInputLabel: t("global.filterPanelInputLabel"),
    filterPanelInputPlaceholder: t("global.filterPanelInputPlaceholder"),
    columnMenuSortAsc: t("global.columnMenuSortAsc"),
    columnMenuSortDesc: t("global.columnMenuSortDesc"),
    columnMenuHideColumn: t("global.columnMenuHideColumn"),
    columnMenuFilter: t("global.columnMenuFilter"),
    columnsManagementNoColumns: t("global.columnsManagementNoColumns"),
    columnsManagementShowHideAllText: t("global.columnsManagementShowHideAllText"),
    columnsManagementReset: t("global.columnsManagementReset"),
    columnsManagementSearchTitle: t("global.columnsManagementSearchTitle"),
    columnMenuManageColumns: t("global.columnMenuManageColumns"),
    filterOperatorContains: t("global.filterOperatorContains"),
    filterOperatorEquals: t("global.filterOperatorEquals"),
    filterOperatorStartsWith: t("global.filterOperatorStartsWith"),
    filterOperatorEndsWith: t("global.filterOperatorEndsWith"),
    filterOperatorIs: t("global.filterOperatorIs"),
    filterOperatorNot: t("global.filterOperatorNot"),
    filterOperatorAfter: t("global.filterOperatorAfter"),
    filterOperatorOnOrAfter: t("global.filterOperatorOnOrAfter"),
    filterOperatorBefore: t("global.filterOperatorBefore"),
    filterOperatorOnOrBefore: t("global.filterOperatorOnOrBefore"),
    filterOperatorIsEmpty: t("global.filterOperatorIsEmpty"),
    filterOperatorIsNotEmpty: t("global.filterOperatorIsNotEmpty"),
    columnMenuUnsort: t("global.columnMenuUnsort"),
    footerRowSelected: (count: number) => count > 1 ? count + " " + t("global.footerRowsSelected") : count + " " + t("global.footerRowSelected"),
    paginationRowsPerPage: t("global.paginationRowsPerPage"),
    filterOperatorDoesNotContain: t("global.filterOperatorDoesNotContain"),
    filterOperatorDoesNotEqual: t("global.filterOperatorDoesNotEqual"),
    filterOperatorIsAnyOf: t("global.filterOperatorIsAnyOf"),
    toolbarQuickFilterLabel: t("global.toolbarQuickFilterLabel"),
    toolbarExport: t("global.toolbarExport"),
    toolbarFilters: t("global.toolbarFilters"),
  };

  const theme = createTheme(
    {
      palette: {
        primary: { main: "#188fa5" },
      },
    },
    // ptBR
  );
  const [groupsUsers, , , groupsUsersFetch]: any = useFetch({
    autoInit: false,
  });

  useEffect(() => {
    if (company_uid) {
      groupsUsersFetch({ url: a.API_USERS_GROUPS_AUDIOFOCO(company_uid) });
    }
  }, [hasUserChangedGroup]);

  useEffect(() => {
    if (setHandleGroup) {
      setHandleGroup(groupsUsers);
    }
  }, [groupsUsers]);

  const handleOpen = (user: any) => {
    setuserProfile(user);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const location = useLocation();
  const profileType = location.pathname.split("/").pop();

  const isProfileSmart = profileType === "smart";
  const isProfileGo = profileType === "go";


  const statusObj: any = {
    "-2": {
      title: "precadastro",
      icon: faIdCard,
      color: "#007085",
    },
    "-1": {
      title: "cadastro",
      icon: faIdCard,
      color: "#007085",
    },
    "0": {
      title: "avaliacao",
      icon: faFileAlt,
      color: "#7418A5",
    },
    "1": {
      title: "treino",
      icon: faDumbbell,
      color: "#003039",
    },
    "2": {
      title: "reavaliacao",
      icon: faFileAlt,
      color: "#7418A5",
    },
    "3": {
      title: "fimjornada",
      icon: faTrophy,
      color: "#469762",
    },
    "4": {
      title: "treino",
      icon: faDumbbell,
      color: "#003039",
    },
  };

  function getUserStatus(user: any) {
    let status: any = "";
    status = statusObj[user.journey_code?.toString()];
    if (status == undefined && user.birthdate == null) {
      status = statusObj["-2"];
    } else if (status == undefined) {
      status = statusObj["4"];
    }
    return status;
  }

  const stringOperators = getGridStringOperators().filter(
    (operator) => operator.value !== 'isAnyOf'
  );
  const [datagridMount, setdatagridMount] = useState([]);
  useEffect(() => {
    let filterElement: any;

    const mountedGrid: GridColDef<(typeof usersRows)[number]>[] = [
      {
        field: "userStatus",
        headerName: t("userProfile.acess"),
        flex: 0.1,
        filterable: false,
        editable: false,
        valueGetter: function (value: any, row: any) {
          if (!row?.toolbox) return "";
          return t("userProfile.status_" + Boolean(Number(row.toolbox.active)));
        },
        renderCell: function renderUser(params: any) {
          const renderVal: any = params.row;
          const textStatus: any = Boolean(
            Number(renderVal.toolbox.active)
          ).toString();
          return (
            <>
              <Tooltip
                title={"" + t("userProfile.status_" + textStatus)}
                placement="left"
              >
                <div
                  className={
                    renderVal.toolbox.active
                      ? pClasses.activeUser
                      : pClasses.deactiveUser
                  }
                >
                  <FontAwesomeIcon size="xs" icon={faCircle} />
                </div>
              </Tooltip>
            </>
          );
        },
      },
      {
        field: "registry",
        headerName: t("userProfile.id"),
        filterOperators: stringOperators,
        minWidth: 20,
        flex: 0.3,
        editable: false,
      },
      {
        field: "group_name",
        headerName: t("userProfile.group_name"),
        filterOperators: stringOperators,
        minWidth: 20,
        flex: 0.2,
        editable: false,
      },
      {
        field: "birthdate",
        headerName: t("userProfile.birthdate"),
        filterOperators: stringOperators,
        minWidth: 180,
        flex: 0.5,
        align: "center",
        editable: false,
      },
      {
        field: "date_IA_start",
        headerName: t("userProfile.initTrain"),
        filterOperators: stringOperators,
        minWidth: 150,
        maxWidth: 150,
        flex: 0.5,
        editable: false,
      },
      {
        field: "date_IA_finish",
        headerName: t("userProfile.endTrain"),
        filterOperators: stringOperators,
        minWidth: 50,
        flex: 0.2,
        editable: false,
      },
      {
        field: "access_code",
        headerName: t("userProfile.acesscode"),
        filterOperators: stringOperators,
        minWidth: 100,
        maxWidth: 120,
        flex: 0.3,
        filterable: false,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: function renderTools(params: any) {
          const copyFunc = (event: any) => {
            navigator.clipboard.writeText(params.formattedValue);
            const spanElement = event.target.querySelector("#copyText");
            if (spanElement) {
              spanElement?.classList?.add(pClasses.copyAnim);
              setTimeout(() => {
                spanElement?.classList?.remove(pClasses.copyAnim);
              }, 1000);
            }
            event.stopPropagation();
          };
          return (
            <>
              {params.formattedValue ? (
                <Button
                  type="button"
                  color="primary"
                  endIcon={
                    <FontAwesomeIcon
                      icon={faCopy}
                      className={pClasses.copyIcon}
                    />
                  }
                  onClick={copyFunc}
                >
                  {params.formattedValue}
                  <span className={pClasses.copyText} id="copyText">
                    {t("userProfile.copy")}
                  </span>
                </Button>
              ) : null}
            </>
          );
        },
      },
      {
        field: "status",
        headerName: t("userProfile.status"),
        filterOperators: stringOperators,
        minWidth: 160,
        flex: 0,
        editable: false,
        align: "center",
        filterable: false,
        headerAlign: "center",
        valueGetter: (params: any) => {
          if (!params || !params.row) return "";
          return params.row.status.title;
        },
        valueFormatter: (value: any, params: any) => {
          return params.status.title;
        },
        renderCell: function renderTools(params: any) {
          const renderVal: any = params.row.status;
          return (
            <>
              <div>{createChip(renderVal)}</div>
            </>
          );
        },
      },
      {
        field: "amt_plays",
        headerName: t("userProfile.plays"),
        minWidth: 138,
        flex: 0,
        type: "number",
        align: "center",
        headerAlign: "center",
        editable: false,
      },
      {
        field: "date_last_play",
        headerName: t("userProfile.last_plays"),
        filterOperators: stringOperators,
        minWidth: 200,
        flex: 0.3,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "professional_email",
        headerName: t("global.updated_by"),
        minWidth: 200,
        flex: 0.6,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "toolbox",
        headerName: t("userProfile.profile"),
        filterOperators: stringOperators,
        minWidth: 200,
        flex: 0.3,
        disableExport: true,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: false,
        filterable: false,
        renderCell: function renderTools(params: any) {
          const handleOpenEvent = (e: any) => {
            handleOpen(params);
            e.stopPropagation();
          };
          return (
            <>
              <div>
                <Button
                  type="button"
                  size="small"
                  color="primary"
                  startIcon={<FontAwesomeIcon size="xs" icon={faUser} />}
                  onClick={handleOpenEvent}
                >
                  {t("userProfile.open_profile")}
                </Button>
              </div>
            </>
          );
        },
      },
      {
        field: "url",
        headerName: t("userProfile.link"),
        filterOperators: stringOperators,
        minWidth: 200,
        flex: 0.3,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: false,
        filterable: false,
      },
      {
        field: "remove",
        headerName: t("userProfile.remove"),
        filterOperators: stringOperators,
        minWidth: 200,
        flex: 1,
        disableExport: true,
        editable: false,
        align: "center",
        renderCell: function removebutton(params: any) {
          const removeConfirm = (e: any) => {
            const text = t("global.confirmRemove");
            if (window.confirm(text) == true) {
              removeEntry(e);
            }
          };
          const removeEntry = (e: any) => {
            handleDelete(params.id);
            e.stopPropagation();
          };
          return (
            <>
              <div>
                <Button
                  type="button"
                  size="small"
                  color="secondary"
                  startIcon={<FontAwesomeIcon icon={faUser} />}
                  onClick={removeConfirm}
                  variant="outlined"
                >
                  {t("userProfile.remove")}
                </Button>
              </div>
            </>
          );
        },
      },
    ];
    if (configFields) {
      filterElement = mountedGrid.filter((item: any) => {
        
        //* remove coluna status se for GO
        if (isProfileGo && !isProfileSmart && item.field === "status") {
          return false;
        }

        if (item.field in configFields) {
          item.hide = configFields[item.field].hide;
          item.editable = configFields[item.field].editable;
        }
        return item;
      });
      const newArray = filterElement.filter(
        (item: any, index: any) => item.field in configFields
      );
      filterElement = newArray;
    } else {
      filterElement = mountedGrid;
    }
    setdatagridMount(filterElement);
  }, [configFields]);

  useEffect(() => {
    if (users && datagridMount && Object.keys(datagridMount).length > 0) {
      const customTemplate: any = [];
      users.forEach((user: any, index: number) => {
        let _url: string | undefined = "";
        try {
          _url = copyFunc(
            {
              uid: user.registry,
              cid: user.company_uid,
              acess: user.access_code,
            },
            true,
            true
          );
        } catch (err) {
          console.log("err", err);
        }
        const tmpUser: any = {};
        datagridMount.map((col: any) => {
          tmpUser[col.field] = user[col.field];
          tmpUser["id"] = index;
          tmpUser["uid"] = user["user_id"];
          tmpUser["group_name"] = user["group_name"];
          tmpUser["date_last_play"] = user["date_last_play"]
            ? h.getSplitedDate(user["date_last_play"])
            : "";
          tmpUser["date_IA_start"] = user["date_IA_start"]
            ? h.getSplitedDate(user["date_IA_start"])
            : "";
          tmpUser["date_IA_finish"] = user["date_IA_start"]
            ? h.getSplitedDate(user["date_IA_finish"])
            : "";
          tmpUser["status"] = getUserStatus(user);
          tmpUser["plays"] = user["active"];
          tmpUser["toolbox"] = user;
          tmpUser["url"] = _url;
          tmpUser["birthdate"] = h.correctBirthdate(
            user.birthdate?.toString().replace(/\s/, "T")
          );
        });

        if (Object.keys(tmpUser).length > 0) customTemplate.push(tmpUser);
      });
      setusersRows(customTemplate);
    }
  }, [users, datagridMount]);

  // Estado para controlar quantidade de itens por página (começa com 50)
  const [pageSize, setPageSize] = useState<number>(50);

  // Estado para guardar o valor digitado no filtro
  const [filterModelValue, setFilterModelValue] = useState<string>("");

  // Estado para guardar o operador do filtro (ex: contém, igual, começa com...)
  const [filterModelOperator, setFilterModelOperator] =
    useState<string>("contains");

  // Estado para guardar o campo da tabela que está sendo filtrado
  const [filterModelField, setFilterModelField] = useState<string>("registry");

  // Modelo de paginação inicial
  const paginationModel = { page: 0, pageSize: pageSize };

  // Ref usado para armazenar o timeout do filtro (evita rodar em cada tecla digitada)
  const filterTimeout = useRef<any>(null);

  useEffect(() => {
    if (Object.keys(datagridMount).length > 0 && usersRows.length > 0)
      setDataGrid(
        <DataGrid
          rows={usersRows}
          columns={datagridMount} 
          // Define o filtro atual (campo, operador e valor)
          filterModel={{
            items: [
              { field: filterModelField, operator: filterModelOperator, value: filterModelValue },
            ]
          }}
          showToolbar
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={Array.from(new Set([pageSize, 50, 100])).sort((a, b) => a - b)}
          onPaginationModelChange={(newPaginationModel) =>
            setPageSize(newPaginationModel.pageSize)
          }
          localeText={customLocaleText}
          columnVisibilityModel={columnVisibilityModel}
          checkboxSelection
          disableRowSelectionOnClick
          // Ignora acentos nos filtros
          ignoreDiacritics
          // Filtro por campo (quando o usuário usa os filtros nas colunas)
          onFilterModelChange={(filterModel) => {
            // cancela qualquer timeout anterior
            clearTimeout(filterTimeout.current);

            // inicia novo timeout (ex: 5s)
            filterTimeout.current = setTimeout(() => {

              // Se não tiver filtros, reseta os valores
              if (filterModel.items.length === 0) {
                setFilterModelValue("");
                setFilterModelOperator("contains");
                setFilterModelField("registry");
              }

              // Filtra os dados com base no filtro ativo
              const filteredRows = users.filter((user: any) => {
                return filterModel.items.every((filter) => {
                  const fieldValue = user[filter.field]?.toString() || "";
                  setFilterModelValue(filter.value || "");
                  setFilterModelOperator(filter.operator);
                  setFilterModelField(filter.field);

                  // Se tiver valor, faz comparação ignorando maiúsc/minúsc
                  if (filter.value)
                    return fieldValue
                      .toLowerCase()
                      .includes(filter.value.toLowerCase());
                  else return true;
                });
              });

              // Constrói o array com os dados filtrados
              const customTemplate: any = [];
              filteredRows.forEach((user: any, index: number) => {
                let _url: string | undefined = "";
                try {
                  _url = copyFunc(
                    {
                      uid: user.registry,
                      cid: user.company_uid,
                      acess: user.access_code,
                    },
                    true,
                    true
                  );
                } catch (err) {
                  console.log("err", err);
                }
                const tmpUser: any = {};
                datagridMount.map((col: any) => {
                  tmpUser[col.field] = user[col.field];
                  tmpUser["id"] = index;
                  tmpUser["uid"] = user["user_id"];
                  tmpUser["group_name"] = user["group_name"];
                  tmpUser["date_last_play"] = user["date_last_play"]
                    ? h.getSplitedDate(user["date_last_play"])
                    : "";
                  tmpUser["date_IA_start"] = user["date_IA_start"]
                    ? h.getSplitedDate(user["date_IA_start"])
                    : "";
                  tmpUser["date_IA_finish"] = user["date_IA_start"]
                    ? h.getSplitedDate(user["date_IA_finish"])
                    : "";
                  tmpUser["status"] = getUserStatus(user);
                  tmpUser["plays"] = user["active"];
                  tmpUser["toolbox"] = user;
                  tmpUser["url"] = _url;
                  tmpUser["birthdate"] = h.correctBirthdate(
                    user.birthdate?.toString().replace(/\s/, "T")
                  );
                });

                if (Object.keys(tmpUser).length > 0)
                  customTemplate.push(tmpUser);
              });

              // Atualiza o estado com as novas linhas filtradas
              setusersRows(customTemplate);
            }, 1000); // ← delay de 1 segundos
          }}
          // Define o componente customizado para a barra de ferramentas
          slots={{ toolbar: CustomToolbar }}
          // Props da barra de ferramentas: habilita busca rápida com debounce de 5s
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 3000 },
            },
          }}
          onColumnVisibilityModelChange={(newModel) => { setColumnVisibilityModel(newModel); }}
          onRowSelectionModelChange={(r) => { handleSelectRowsToSetGroup?.(Array.from(r.ids) || []); }}
        />
      );
  }, [userProfile, usersRows, datagridMount, pageSize, columnVisibilityModel]);

  let _content;

  const handleCellEditCommit = React.useCallback(
    ({ id, field, value }: any) => {
      if (field === "registry") {
        // const [firstName, lastName] = value!.toString().split(' ');
        const updatedRows: any = usersRows.map((row: any) => {
          if (row.id === id) {
            row.registry = value;
            return row;
            // return { ...row, value };
          }

          return row;
        });

        setusersRows(updatedRows);
        callback(updatedRows);
      }
    },
    [usersRows]
  );

  function updateCalback(user: any, status: boolean) {
    const usersRowsUpdate = usersRows;
    usersRowsUpdate.map((u: any) => {
      if (user.user_id == u.uid) {
        u.toolbox.active = Number(status);
      }
    });

    setusersRows(usersRowsUpdate);
  }

  function createChip(renderVal: any) {
    const StyleChip = styled(Chip)(({ theme }) => ({
      root: {
        color: renderVal.color,
        borderColor: renderVal.color,
        fontWeight: 500,
      },
      icon: {
        color: renderVal.color,
      },
    }));

    const returnChip = (
      <StyleChip
        variant="outlined"
        label={t("global." + renderVal.title)}
        icon={<FontAwesomeIcon icon={renderVal.icon} style={{ color: renderVal.color }} />}
        style={{ borderColor: renderVal.color, color: renderVal.color, fontWeight: 500 }}
      />
    );
    return returnChip;
  }
  useEffect(() => {
    if (listUsers.length === 0) _content = <FriendlyInfo />;
  }, [listUsers]);

  return (
    <>
      <div className={className + " " + pClasses.TableArea}>{_content}</div>
      <div style={{ height: 580, width: "100%" }}>
        <ThemeProvider theme={theme}>{dataGrid}</ThemeProvider>
        {userProfile ? (
          <Profile
            userProfile={userProfile}
            openProfile={open}
            groupsUsers={groupsUsers}
            open={open}
            onCloseModal={handleClose}
            updateCalback={updateCalback}
          ></Profile>
        ) : null}
        <div></div>
      </div>
    </>
  );
}
